import React, { useState } from "react";
import BaseInput from "@reusables/BaseInput";
import BaseMaterialIconButton from "@/components/reusables/BaseMaterialIconButton";
import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ProductAlternativeNameEditProps {
    initialValue: string;
    onSave: (value: string) => void;
    onCancel: () => void;
}

export const ProductAlternativeNameEdit = ({
    initialValue,
    onSave,
    onCancel,
}: ProductAlternativeNameEditProps) => {
    const { t } = useTranslation("", {
        keyPrefix: "sales.orders.general.orders.modals.addProduct",
    });

    const [value, setValue] = useState(initialValue);

    return (
        <BaseInput
            value={value}
            onChange={(val) => setValue(val as string)}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    e.stopPropagation();
                    onSave(value);
                }
            }}
            label={
                <div className="flex items-center justify-between">
                    <span>{t("fields.product.label")} *</span>
                    <div className="flex gap-1">
                        <BaseMaterialIconButton
                            onClick={onCancel}
                            icon={<X size={16} />}
                            size="tiny"
                            style="dim"
                        />
                        <BaseMaterialIconButton
                            onClick={() => onSave(value)}
                            icon={<Check size={16} />}
                            size="tiny"
                            style="dim"
                        />
                    </div>
                </div>
            }
            autoFocus
        />
    );
};
